/*
  product-sticky-buy.js
  Pins the PDP quantity + Add to cart row (.poco-buy-dock) to the bottom of
  the viewport on mobile.

  position: fixed resolves against the nearest transformed ancestor, and the
  theme puts `transform` on the .scroll-trigger / animate--* wrappers around
  the product info — which is why the dock scrolled with the page instead of
  pinning. Re-parenting it to <body> restores a viewport-relative fixed.
*/
(function () {
  'use strict';

  function dockToBody() {
    var dock = document.querySelector('.poco-buy-dock');
    if (!dock) return;
    var mobile = window.matchMedia('(max-width: 991px)').matches;

    if (mobile) {
      if (dock.dataset.docked === '1') return;
      var ph = document.createElement('div');
      ph.className = 'poco-buy-dock__placeholder';
      ph.hidden = true;
      dock.parentNode.insertBefore(ph, dock);
      dock._pgHome = ph;
      document.body.appendChild(dock);
      dock.dataset.docked = '1';

      /* Inline so the pinning does not depend on stylesheet load order or on
         selectors that stopped matching once the dock left #MainProduct. */
      dock.style.setProperty('position', 'fixed', 'important');
      dock.style.setProperty('left', '0', 'important');
      dock.style.setProperty('right', '0', 'important');
      dock.style.setProperty('bottom', '0', 'important');
      dock.style.setProperty('width', 'auto', 'important');
      dock.style.setProperty('z-index', '999990', 'important');
      dock.style.setProperty('display', 'flex', 'important');
      dock.style.setProperty('transform', 'none', 'important');

      /* Reserve the dock's height so the last of the page is reachable. */
      var pad = function () {
        document.body.style.paddingBottom = dock.offsetHeight + 'px';
      };
      pad();
      if ('ResizeObserver' in window) new ResizeObserver(pad).observe(dock);
    } else if (dock.dataset.docked === '1' && dock._pgHome && dock._pgHome.parentNode) {
      dock._pgHome.parentNode.insertBefore(dock, dock._pgHome);
      dock._pgHome.remove();
      dock._pgHome = null;
      dock.dataset.docked = '0';
      dock.removeAttribute('style');
      document.body.style.paddingBottom = '';
    }
  }


  dockToBody();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dockToBody);
  }
  window.addEventListener('load', dockToBody);
  document.addEventListener('shopify:section:load', dockToBody);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(dockToBody, 150);
  });

  /* Variant changes re-render the buy buttons, which can put a fresh dock
     back inside the product info wrapper. */
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var d = document.querySelector('.poco-buy-dock');
      if (d && d.parentElement !== document.body && window.matchMedia('(max-width: 991px)').matches) {
        d.dataset.docked = '0';
        dockToBody();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
